import { render } from "./RejectionOrders.vue?vue&type=template&id=4efba4c4"
import script from "./RejectionOrders.vue?vue&type=script&lang=js"
export * from "./RejectionOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/RejectionOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4efba4c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4efba4c4', __exports__)) {
    console.log('reload')
    api.reload('4efba4c4', __exports__)
  }
  
  module.hot.accept("./RejectionOrders.vue?vue&type=template&id=4efba4c4", () => {
    console.log('re-render')
    api.rerender('4efba4c4', render)
  })

}


export default __exports__